/* eslint-disable react/no-array-index-key */
/* eslint-disable class-methods-use-this */
import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import styles from './Sidebar.scss'
import Heading from 'components/Heading'
import Card from 'components/Card'
import { Link } from 'react-router-dom'
import classnames from 'classnames'
import constants from 'constants'
import { hasAccess } from 'utils/hasAccess'
import { SidebarPartnerPlan, SidebarPartnerPlanNav } from '../../views/PartnerPlans/components/Sidebar'
import ManagePermissions from 'containers/ManagePermissions'

class Sidebar extends Component {
  static propTypes = {
    type: PropTypes.string,
  }
  static defaultProps = {
    type: 'partnerSideBar',
  }
  constructor(props) {
    super(props)
    this.state = {}
  }

  handleRedirectPartnerplan = (redirecUrl) => {
    window.open(redirecUrl, '_blank')
  }

  renderPersonalInfo(partnerInfo, partnerPlanSideNav) {
    if (partnerInfo && partnerInfo.length > 0) {
      return (
        <div className={styles.base}>
          <div className={styles.head}>
            <Heading className={styles.heading} size="joel">Employee information</Heading>
            <hr className={styles.hr} />
            <div className={styles.container}>
              <div className={styles.label}>Employee ID:</div>
              <div className={styles.value}>{partnerInfo[0].employee_id ? partnerInfo[0].employee_id : ''}</div>
            </div>
            <div className={styles.container}>
              <div className={styles.label}>Status:</div>
              <div className={styles.value}>{(partnerInfo[0].status) ? partnerInfo[0].status : 'Inactive'}</div>
            </div>
          </div>
          <div className={classnames(styles.head, styles.topPadding)}>
            <Heading className={styles.heading} size="joel">Key contacts</Heading>
            <hr className={styles.hr} />
            <div className={styles.container}>
              <div className={styles.label}>Counselling Partner:</div>
              <div className={styles.value}>{partnerInfo[0].Counselling_Partner_Name ? partnerInfo[0].Counselling_Partner_Name : ''}</div>
            </div>
            <div className={styles.container}>
              <div className={styles.label}>Business Leader:</div>
              <div className={styles.value}>{partnerInfo[0].Business_Leader_Name ? partnerInfo[0].Business_Leader_Name : ''}</div>
            </div>
            {/* User Story ID 59521 - Remove market leader on all areas in EPIC
            <div className={styles.container}>
              <div className={styles.label}>Market Leader:</div>
              <div className={styles.value}>{partnerInfo[0].Market_Leader_Name ? partnerInfo[0].Market_Leader_Name : ''}</div>
            </div> */}
            <div className={styles.container}>
              <div className={styles.label}>Growth Leader:</div>
              <div className={styles.value}>{partnerInfo[0].Client_Industry_Leader_Name ? partnerInfo[0].Client_Industry_Leader_Name : ''}</div>
            </div>
          </div>
          <SidebarPartnerPlanNav partnerPlanSideNav={partnerPlanSideNav} />
        </div>
      )
    }

    return (
      <div className={styles.base}>
        <div className={styles.head}>
          <Heading className={styles.heading} size="joel">Employee information</Heading>
          <hr className={styles.hr} />
          <div className={styles.container}>
            <div className={styles.label}>Employee ID:</div>

          </div>
          <div className={styles.container}>
            <div className={styles.label}>Status:</div>
          </div>
        </div>
        <div className={classnames(styles.head, styles.topPadding)}>
          <Heading className={styles.heading} size="joel">Key contacts</Heading>
          <hr className={styles.hr} />
          <div className={styles.container}>
            <div className={styles.label}>Counselling Partner:</div>
          </div>
          <div className={styles.container}>
            <div className={styles.label}>Business Leader:</div>
          </div>
          {/* User Story ID 59521 - Remove market leader on all areas in EPIC
          <div className={styles.container}>
            <div className={styles.label}>Market Leader:</div>
          </div> */}
          <div className={styles.container}>
            <div className={styles.label}>Growth Leader:</div>
          </div>
        </div>
      </div>
    )
  }

  renderAdmin() {
    return (
      <section className={styles.adminfunction}>
        <Heading noTopPadding>Admin functions</Heading>
        <Card cardAdmin>
          { constants.ADMINCENTRE.SIDEBAR.map((item, i) => {
            if (hasAccess(this.props.currentUser, item.permission, this.props.history, 'RW', false)) {
              switch (item.type) {
                case constants.ADMINCENTRE_TYPE.MODAL:
                  return <div className={styles.optionadmins} id={item.key} key={`${item.key}-${i}`} onClick={() => this.props.modalShow(item.modalId)}>{item.label}</div>
                case constants.ADMINCENTRE_TYPE.DIALOG:
                  return <div className={styles.optionadmins} id={item.key} key={`${item.key}-${i}`} onClick={() => this.handleOpenDialog(item.label)}>{item.label}</div>
                default:
                  return <div className={styles.optionadmins} id={item.key} key={`${item.key}-${i}`}><Link to={item.path}>{item.label}</Link></div>
              }
            }
            return <div />
          })}
        </Card>
        <ManagePermissions currentUserId={this.props.currentUser.EmployeeId} hide={this.props.modalHide} />
      </section>
    )
  }

  render() {
    // eslint-disable-next-line react/prop-types
    const {
      partnerSideBarInfo, partnerPlanDocuments, handleOpenDialog, partnerPlanSideNav,
    } = this.props

    switch (this.props.type) {
      case 'partnerSideBar': {
        return (this.renderPersonalInfo(partnerSideBarInfo, partnerPlanSideNav))
      }
      case 'partnerAdmin': {
        return (this.renderAdmin())
      }
      case 'partnerPlan': {
        return (<SidebarPartnerPlan handleOpenDialog={handleOpenDialog} partnerPlanDocuments={partnerPlanDocuments} />)
      }
      default: {
        return (<div />)
      }
    }
  }
}

function mapStateToProps(state) {
  const { personalInfo, adminCentre } = state
  return {
    personalInfo: {
      employeeInfo: { id: '12345', status: 'Active' },
      keyContacts: { counsellingPartner: 'Rogier Pippers', businessLeader: 'Brad Greacen', clientIndLeader: 'Jason Li' },
    },
    adminCentre: {

    },
  }
}

export default connect(mapStateToProps, { /* createPartnerplanForFY, bulkUpdatePartnerPlanStatus */ })(Sidebar)



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js